<template>
  <div>
    <vx-card title="Statistiques globales">
      <vs-row>
        <vs-col vs-w="8">
          <span class="vs-select--label">Période</span>
          <date-range-picker
            ref="picker"
            :opens="opens"
            :locale-data=locale
            :singleDatePicker="false"
            :timePicker=false
            :showWeekNumbers="showWeekNumbers"
            :showDropdowns="showDropdowns"
            :autoApply="autoApply"
            v-model="dateRange"
            :ranges=false
            @update="updateValues"
            :linkedCalendars="linkedCalendars"
            :dateFormat="dateFormat"
            :always-show-calendars="false"
            :alwaysShowCalendars="alwaysShowCalendars"
            class="vs-inputx vs-input--input"
          >
            <div slot="input" slot-scope="picker" style="min-width: 350px;">
              {{ picker.startDate | date }} - {{ picker.endDate | date }}
            </div>
          </date-range-picker>
        </vs-col>

        <vs-col vs-w="4">
          <span>Status</span>
          <v-select v-model="form.status" class="w-full" label="name"
                    placeholder="Sélectionner un charger"
                    :reduce="user => user.id"
                    :options="types"></v-select>
          <span style="color: red; font-size: 10px" v-if="errors_data.status">Selectionner un status</span>
        </vs-col>
      </vs-row>
      <vs-row style="margin-top: 20px">
        <vs-col vs-w="5">
          <span>Liste des clients</span>
          <v-select v-model="form.customer" class="w-full" label="social_reason"
                    placeholder="Sélectionner un client"
                    :reduce="user => user.id"
                    :options="customers"></v-select>
        </vs-col>

        <vs-col vs-w="3">
          <span>Type de demande</span>
          <v-select v-model="form.category" class="w-full" label="name"
                    placeholder="Sélectionner une catégorie"
                    :reduce="type => type.id"
                    :options="categories"></v-select>
        </vs-col>

        <vs-col vs-w="4">
          <vs-button color="primary" style="margin-top: 20px; margin-right: 8px" type="filled"
                     :disabled="exporting || (dateRange.startDate === '' && dateRange.endDate === '')"
                     @click="exportStats()">Exporter</vs-button>
          <vs-button color="primary" style="margin-top: 20px" type="filled"
                     :disabled="exporting || (dateRange.startDate === '' && dateRange.endDate === '')"
                     @click="exportSlaReport()">Exporter rapport SLA</vs-button>
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
  import DateRangePicker from 'vue2-daterange-picker';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from "moment";
    const default_value = {
      date_debut: '',
      date_fin: '',
      status: '-1',
      customer: '',
      category: ''
    }
    export default {
        name: "requestStat",
      components: {DateRangePicker},
      data: () => ({
        locale: {
          direction: 'ltr',
          format: 'dd/mm/yyyy',
          separator: ' - ',
          applyLabel: 'Appliquer',
          cancelLabel: 'Annuler',
          weekLabel: 'W',
          customRangeLabel: 'Custom Range',
          daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
          monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
          firstDay: 0
        },
        opens: 'center',
        showWeekNumbers: true,
        linkedCalendars: true,
        alwaysShowCalendars: true,
        showDropdowns: true,
        autoApply: false,
        dateRange: {
          startDate: "",
          endDate: "",
        },
        form:{
          date_debut: '',
          date_fin: '',
          status: '-1',
          customer: '',
          category: ''
        },
        customers: [],
        categories: [],
        types: [
          {name: 'Tous', id: '-1'},
          {name: 'Reçu', id: '0'},
          {name: 'En cours de traitement', id: '1'},
          {name: 'Traitée', id: '2'},
        ],
        errors_data: [],
        exporting: false
      }),
      mounted() {
          this.getCustomers()
          this.getCategories()
          this.dateRange.startDate = moment(new Date()).format('YYYY-MM-DD')
          this.dateRange.endDate = moment(new Date()).format('YYYY-MM-DD')
      },
      methods:{
        updateValues(values) {
          this.dateRange.startDate = moment(values.startDate).format('YYYY-MM-DD');
          this.dateRange.endDate = moment(values.endDate).format('YYYY-MM-DD');
        },
        dateFormat(classes, date) {
          let yesterday = moment().subtract(1, 'day');
          if (!classes.disabled) {
            //classes.disabled = moment(date).isSame(yesterday, 'day')
          }
          return classes
        },
        async getCustomers() {
          this.$vs.loading()
          let response = await this.$store.state.customers({})
            .catch((error) => {
              console.log('error: ', error)
            });
          this.customers = response.data;
          this.$vs.loading.close()
        },
        async getCategories() {
          let response = await this.$store.state.categories_requests({}, { paginate: 0 })
            .catch((error) => {
              console.log('error: ', error)
            });
          this.categories = response.data;
        },
        exportStats() {
          return this.downloadExport('/statistics/requests/export', 'statsAll.xlsx')
        },
        exportSlaReport() {
          return this.downloadExport('/statistics/requests/sla-report', 'rapport_sla_requetes.xlsx')
        },
        buildExportPayload() {
          this.form.date_debut = this.dateRange.startDate
          this.form.date_fin = this.dateRange.endDate
          return this.form
        },
        triggerDownload(blob, filename) {
          const url = window.URL.createObjectURL(new Blob([blob]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        },
        async downloadExport(url, filename) {
          this.$vs.loading()
          this.exporting = true
          try {
            const response = await this.$http.post(url, this.buildExportPayload(), {
              responseType: 'blob',
              timeout: 180000,
            })

            const contentType = response.headers['content-type'] || ''
            if (contentType.indexOf('spreadsheetml') === -1) {
              this.errors_data = await this.parseBlobError(response.data)
              this.notifyError(this.firstErrorMessage(this.errors_data))
              return
            }

            this.triggerDownload(response.data, filename)
            this.errors_data = []
            this.form = { ...default_value }
          } catch (error) {
            if (error.response && error.response.status === 401) {
              this.notifyError('Votre session a expiré')
              this.$router.push({name: "login"})
            } else if (error.response) {
              this.errors_data = await this.parseBlobError(error.response.data)
              this.notifyError(this.firstErrorMessage(this.errors_data))
            } else {
              this.notifyError(error.code === 'ECONNABORTED'
                ? "Le rapport n'a pas pu être généré dans le délai de 3 minutes"
                : 'Une erreur est survenue, veuillez réessayer')
            }
          } finally {
            this.$vs.loading.close()
            this.exporting = false
          }
        },
        readBlob(blob) {
          return new Promise((resolve) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.readAsText(blob)
          })
        },
        async parseBlobError(blob) {
          try {
            const parsed = JSON.parse(await this.readBlob(blob))
            const errors = parsed.errors
            if (typeof errors === 'string' && errors !== '') return {_global: [errors]}
            if (errors && typeof errors === 'object') return errors
            if (typeof parsed.message === 'string' && parsed.message !== '') return {_global: [parsed.message]}
            return {_global: ['Une erreur est survenue, veuillez réessayer']}
          } catch (e) {
            return {_global: ['Une erreur est survenue, veuillez réessayer']}
          }
        },
        firstErrorMessage(errors) {
          const messages = []
          Object.keys(errors).forEach((key) => {
            const value = errors[key]
            if (Array.isArray(value)) {
              value.forEach((item) => messages.push(item))
            } else if (typeof value === 'string') {
              messages.push(value)
            }
          })
          return messages.length > 0 ? messages.join(' ') : 'Une erreur est survenue, veuillez réessayer'
        },
        notifyError(text) {
          this.$vs.notify({
            title: 'Erreur',
            text: text,
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-check',
            position: 'top-right'
          })
        },
      }
    }
</script>

<style scoped>

</style>
